import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Skeleton, Stack, Tooltip, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

import { OutcomeTileDirection, OutcomeTileDirectionIcon } from './OutcomeTileDirectionIcon'

interface Props {
  color: string
  direction: OutcomeTileDirection
  caption: string
  value: string | null
  valueSuffix?: string | null
  subtitle: string
  info?: string
  loading?: boolean
}

export const NegotiationOutcomeTile = ({
  color,
  direction,
  caption,
  value,
  valueSuffix,
  subtitle,
  info,
  loading,
}: Props) => (
  <Stack direction='row' spacing={1.5} alignItems='center' sx={{ px: 2, py: 1.5, minWidth: 200 }}>
    <Box
      sx={{
        width: 44,
        height: 44,
        borderRadius: '50%',
        border: `2px solid ${color}`,
        bgcolor: alpha(color, 0.12),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
      <OutcomeTileDirectionIcon color={color} direction={direction} />
    </Box>

    <Box>
      <Stack direction='row' spacing={0.5} alignItems='center'>
        <Typography variant='subtitle2' fontWeight={700}>
          {caption}
        </Typography>
        {info && (
          <Tooltip
            title={info}
            slotProps={{ tooltip: { sx: { whiteSpace: 'pre-line', maxWidth: 420 } } }}>
            <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
          </Tooltip>
        )}
      </Stack>

      {loading ? (
        <Skeleton width={72} height={28} />
      ) : (
        <Typography
          variant='body1'
          fontWeight={700}
          sx={{ color: value != null ? color : 'text.primary' }}>
          {value ?? '—'}
          {valueSuffix && (
            <Box component='span' fontWeight={400} color='text.secondary'>
              {` ${valueSuffix}`}
            </Box>
          )}
        </Typography>
      )}

      <Typography variant='caption' color='text.secondary'>
        {subtitle}
      </Typography>
    </Box>
  </Stack>
)
